// ==================== Email Field Labels ====================
export const EMAIL_FIELD_LABELS = {
  TO: 'To',
  CC: 'CC',
  BCC: 'BCC',
  SUBJECT: 'Subject',
  FROM: 'From',
  EMAIL: 'Email',
  TO_RECIPIENT: 'To (Recipient Email)',
  CC_OPTIONAL: 'CC (Optional - Comma separated)',
  EMAIL_BODY: 'Email Body',
  ATTACHMENTS: 'Attachments'
};

// ==================== Email Field Placeholders ====================
export const EMAIL_PLACEHOLDERS = {
  TO: 'Enter to email',
  CC: 'Enter cc email',
  BCC: 'Enter bcc email',
  SUBJECT: 'Enter subject',
  EMAIL: 'Enter Your Email',
  CLIENT_EMAIL: 'client@example.com',
  MULTIPLE_EMAILS: 'email1@example.com, email2@example.com',
  EMAIL_SUBJECT: 'Enter email subject'
};

// ==================== Success Messages ====================
export const EMAIL_SUCCESS_MESSAGES = {
  EMAIL_SENT: 'Email sent successfully',
  EMAIL_UPDATED: 'User Email Updated Successfully',
  EMAIL_SAVED_DRAFT: 'Email saved as draft',
  WEBMAIL_UPDATED: 'Web Mail Profile has been updated Successfully',
  MARKED_AS_READ: 'Email marked as read',
  MARKED_AS_UNREAD: 'Email marked as unread',
  ARCHIVED: 'Email archived successfully',
  DELETED: 'Email deleted successfully',
  ADDED_TO_CONTACTS: 'Added to contacts',
  STARRED: 'Email starred',
  UNSTARRED: 'Email unstarred'
};

// ==================== Error Messages ====================
export const EMAIL_ERROR_MESSAGES = {
  EMAIL_NOT_SENT: 'Failed to send email',
  EMAIL_NOT_UPDATED: 'User Email Not Updated',
  NETWORK_ERROR: 'Network Error',
  UNEXPECTED_SERVER_ERROR: 'Unexpected Server Action',
  FETCH_ERROR: 'Failed to fetch email details'
};

// ==================== Loading Messages ====================
export const EMAIL_LOADING_MESSAGES = {
  SENDING: 'Sending email...',
  SAVING_DRAFT: 'Saving message as draft...',
  FETCHING: 'Fetching email details...',
  UPDATING: 'Updating email...',
  MARKING_READ: 'Marking as read...',
  MARKING_UNREAD: 'Marking as unread...',
  ARCHIVING: 'Archiving Email...',
  ARCHIVING_MULTIPLE: 'Archiving emails...',
  DELETING: 'Moving to Trash...',
  DELETING_PERMANENT: 'Permanently deleting email...',
  DELETING_MULTIPLE: 'Moving to Trash...',
  DELETING_MULTIPLE_PERMANENT: 'Permanently deleting emails...',
  UPDATING_FAVORITES: 'Updating favorites...',
  UPDATING_CONTACTS: 'Updating contacts...',
  MOVING_TO: (folder) => `Moving to ${folder}...`,
  DOWNLOADING: (filename) => `Downloading ( ${filename} )`,
  PREPARING_ATTACHMENTS: 'Preparing original attachments...'
};

// ==================== Confirmation Messages ====================
export const EMAIL_CONFIRMATION_MESSAGES = {
  SAVE_DRAFT_TITLE: 'Save Message As Draft',
  SAVE_DRAFT_TEXT: 'Do you want to save the message as a draft?',
  DELETE_EMAIL_TITLE: 'Delete Email',
  DELETE_EMAIL_TEXT: 'Are you sure you want to delete this email?',
  DELETE_PERMANENT_TEXT: 'This action cannot be undone. Are you sure?'
};

// ==================== Button Labels ====================
export const EMAIL_BUTTON_LABELS = {
  SEND_EMAIL: 'Send Email',
  UPDATE: 'Update',
  SAVE: 'Save',
  DISCARD: 'Discard',
  CANCEL: 'Cancel',
  REPLY: 'Reply',
  REPLY_ALL: 'Reply All',
  FORWARD: 'Forward',
  BACK: 'Back',
  SEND_CODE: 'Send Code',
  COMPOSE: 'Compose',
  COMPOSE_MAIL: 'Compose Mail',
  EDIT_AS_NEW: 'Edit As New'
};

// ==================== Tooltip Messages ====================
export const EMAIL_TOOLTIP_MESSAGES = {
  MARK_AS_READ: 'Mark as read',
  MARK_AS_UNREAD: 'Mark as unread',
  ARCHIVE: 'Archive',
  ADD_STAR: 'Add star',
  REMOVE_STAR: 'Remove star',
  DELETE: 'Delete',
  FORWARD: 'Forward',
  ADD_TO_CONTACTS: 'Add to contacts',
  MOVE_TO: 'Move to...',
  EDIT_AS_NEW: 'Edit as new'
};

// ==================== Email Tabs/Folders ====================
export const EMAIL_FOLDERS = {
  INBOX: 'Inbox',
  SENT: 'Sent',
  DRAFTS: 'Drafts',
  TRASH: 'Trash',
  ARCHIVE: 'Archive',
  SPAM: 'spam',
  STARRED: 'Starred'
};

// ==================== Notification Titles ====================
export const EMAIL_NOTIFICATION_TITLES = {
  SUCCESS: 'Success',
  ERROR: 'Error',
  WARNING: 'Warning',
  INFO: 'Info',
  UPDATED: 'Updated'
};

// ==================== Email Form Headers ====================
export const EMAIL_FORM_HEADERS = {
  SEND_MAIL: 'Send Mail',
  COMPOSE_EMAIL: 'Compose Email',
  CHANGE_EMAIL: 'Change Email',
  EMAIL_FROM_USER: 'From: will be the email of the user who is sending the email'
};

// ==================== Pagination ====================
export const EMAIL_DEFAULT_PAGE_SIZE = 30;

// ==================== Other Constants ====================
export const EMAIL_MISC = {
  NO_ITEMS_FOUND: 'No Items Found',
  SELECT_ALL: 'Select All',
  ATTACHMENTS_DIVIDER: 'Attachments',
  EMAIL_BODY_DIVIDER: 'Email Body'
};

// ==================== Empty State Messages ====================
export const EMAIL_EMPTY_STATE = {
  INBOX: {
    title: 'Your inbox is empty',
    message: 'No emails in your inbox. New messages will appear here.'
  },
  Sent: {
    title: 'No sent emails',
    message: 'You haven\'t sent any emails yet. Sent messages will appear here.'
  },
  Drafts: {
    title: 'No drafts',
    message: 'You don\'t have any saved drafts. Start composing to create one.'
  },
  Archive: {
    title: 'Archive is empty',
    message: 'No archived emails. Archive messages to keep them organized.'
  },
  Trash: {
    title: 'Trash is empty',
    message: 'No deleted emails. Deleted messages will appear here.'
  },
  spam: {
    title: 'No spam emails',
    message: 'No spam messages found. Your spam folder is clean.'
  }
};
